import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['sail', 0.22],
        ['warehouse', 0.78],
      ],
      d: 'M-4,-3.5h1.5v0.5h-1.5zM-4,-3h3v0.5h-3zM-4,-2.5h1v1h-1zM-0.5,-2.5h1v0.5h-1zM0,-2h1.5v1h-1.5zM-3.5,-1.5h0.5v1h-0.5zM1,-1h0.5v1.5h-0.5zM-3,-0.5h0.5v0.5h-0.5zM-1,0h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['shadow', 0.24],
        ['warehouse', 0.76],
      ],
      d: 'M3.5,-3h0.5v1h-0.5zM-3,-2.5h0.5v2h-0.5zM-2,-2.5h1.5v0.5h-1.5zM0.5,-2.5h0.5v0.5h-0.5zM-2,-2h0.5v0.5h-0.5zM-0.5,-2h0.5v2h-0.5zM1.5,-2h0.5v0.5h-0.5zM3,-2h1v0.5h-1zM-1.5,-1.5h0.5v0.5h-0.5zM1.5,-1.5h2.5v1.5h-2.5zM0.5,-1h0.5v0.5h-0.5zM-2.5,-0.5h1v0.5h-1zM-0.5,0h1v0.5h-1zM1.5,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'roofA',
      d: 'M-2.5,-6h0.5v0.5h-0.5zM-3.5,-5.5h2v0.5h-2zM-4,-5h3v0.5h-3zM-4.5,-4.5h4v0.5h-4zM-4.5,-4h4.5v0.5h-4.5zM-2,-3.5h2.5v0.5h-2.5zM-0.5,-3h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['roofA', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-2,-6h1.5v0.5h-1.5zM-1.5,-5.5h3v0.5h-3zM-1,-5h4.5v0.5h-4.5zM-0.5,-4.5h4.5v0.5h-4.5zM0,-4h4.5v0.5h-4.5zM-2.5,-3.5h0.5v0.5h-0.5zM0.5,-3.5h4v0.5h-4zM-1,-3h0.5v0.5h-0.5zM1,-3h2v0.5h-2zM1,-2.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'trunk',
      d: 'M3,-3h0.5v1h-0.5zM-2.5,-2.5h0.5v1.5h-0.5zM-1.5,-2h1v0.5h-1zM2,-2h0.5v0.5h-0.5zM-1,-1.5h0.5v0.5h-0.5zM-2.5,-1h2v0.5h-2zM-1.5,-0.5h1v0.5h-1z',
    },
    { paint: 'fence', d: 'M-2,-1.5h0.5v0.5h-0.5z' },
    { paint: 'shadow', d: 'M2.5,-2.5h0.5v1h-0.5z' },
    {
      paint: 'cart',
      d: 'M-4.5,-2h0.5v0.5h-0.5zM-4.5,-1.5h1v1h-1zM0,-1h0.5v0.5h-0.5zM0,-0.5h1v0.5h-1zM0.5,0h0.5v0.5h-0.5z',
    },
  ],
  pixels: 186,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
